import React, { useState } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import "./User.css";
import axios from "axios";
import { toast } from "react-toastify";
import { IoCloseCircle } from "react-icons/io5";

const backEndURL = `${process.env.REACT_APP_BACKEND_URL}`;

const User = ({ onClose }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [isPasswordVisible, setPasswordVisible] = useState(false);
	const [isLogin, setIsLogin] = useState(true);
	const [loginData, setLoginData] = useState({ email: "", password: "" });
	const [registerData, setRegisterData] = useState({
		name: "",
		email: "",
		password: "",
		confirmPassword: "",
	});

	const togglePasswordVisibility = () => {
		setPasswordVisible(!isPasswordVisible);
	};

	const toggleCard = () => {
		setIsLogin(!isLogin);
		setLoginData({ email: "", password: "" })
		setRegisterData({
			name: "",
			email: "",
			password: "",
			confirmPassword: "",
		})
		setPasswordVisible(true);
	}

	const handleChange = (e, formType) => {
		const { name, value } = e.target;
		if (formType === "login") {
			setLoginData((prev) => ({ ...prev, [name]: value }));
		} else {
			setRegisterData((prev) => ({ ...prev, [name]: value }));
		}
	};

	const handleSubmit = async (e, formType) => {
		e.preventDefault();
		setIsLoading(true);
		try {
			if (formType === "login") {
				const { data } = await axios.post(`${backEndURL}/user/login`, loginData);
				localStorage.setItem("token", data.token);
				localStorage.setItem("userName", data.userName);
				console.log("Token:", data.token);
				toast.success(data.message || "Login Successfull..!", {
					position: "top-center",
					theme: "dark",
				});
				onClose();
			} else {
				const { data } = await axios.post(`${backEndURL}/user/register`, registerData);
				toast.success(data.message || "Registered Successfull..!", {
					position: "top-center",
					theme: "dark",
				});
				setIsLogin(true);
			}
		} catch (error) {
			const errorMessage =
				error.response && error.response.data.message
					? error.response.data.message
					: "An error occurred. Please try again.";
			toast.error(errorMessage, {
				position: "top-center",
				theme: "dark",
			});
		} finally {
			setIsLoading(false);
		};
	};

	return (
		<div className="popupOverlay">
			<div className="popupContainer">
				<button className="closeBtn" onClick={onClose}><IoCloseCircle /></button>
				<h2 className="popupHeader">{isLogin ? "Login" : "Register"}</h2>
				<form
					onSubmit={(e) => handleSubmit(e, isLogin ? "login" : "register")}
					className="popupForm"
				>
					{isLogin ? (
						<>
							<input
								type="email"
								name="email"
								placeholder="Enter Email"
								value={loginData.email}
								onChange={(e) => handleChange(e, "login")}
								className="popupFormInput"
								required
							/>
							<div className="passwordInputWrapper">
								<input
									type={isPasswordVisible ? "text" : "password"}
									name="password"
									id="password"
									placeholder="Enter Password"
									value={loginData.password}
									onChange={(e) => handleChange(e, "login")}
									required
								/>
								<button
									type="button"
									onClick={togglePasswordVisibility}
									className="passwordToggleButton"
								>
									{isPasswordVisible ? <FaRegEye /> : <FaRegEyeSlash />}
								</button>
							</div>
							<button type="submit" disabled={isLoading} className={`popupFormButton ${isLoading ? 'disabled' : ''}`}>
								{isLoading ? (
									<div className="dotContainer">
										<span className="dot"></span>
										<span className="dot"></span>
										<span className="dot"></span>
									</div>
								) : (
									"Login"
								)}
							</button>
						</>
					) : (
						<>
							<input
								type="text"
								name="name"
								placeholder="Enter Name"
								value={registerData.name}
								onChange={(e) => handleChange(e, "register")}
								className="popupFormInput"
								required
							/>
							<input
								type="email"
								name="email"
								placeholder="Enter Email"
								value={registerData.email}
								onChange={(e) => handleChange(e, "register")}
								className="popupFormInput"
								required
							/>
							<div className="passwordInputWrapper">
								<input
									type={isPasswordVisible ? "text" : "password"}
									name="password"
									id="password"
									placeholder="Enter Password"
									value={registerData.password}
									onChange={(e) => handleChange(e, "register")}
									required
								/>
								<button
									type="button"
									onClick={togglePasswordVisibility}
									className="passwordToggleButton"
								>
									{isPasswordVisible ? <FaRegEye /> : <FaRegEyeSlash />}
								</button>
							</div>
							<div className="passwordInputWrapper">
								<input
									type={isPasswordVisible ? "text" : "password"}
									name="confirmPassword"
									placeholder="Confirm Password"
									value={registerData.confirmPassword}
									onChange={(e) => handleChange(e, "register")}
									required
								/>
								<button
									type="button"
									onClick={togglePasswordVisibility}
									className="passwordToggleButton"
								>
									{isPasswordVisible ? <FaRegEye /> : <FaRegEyeSlash />}
								</button>
							</div>
							<button type="submit" disabled={isLoading} className="popupFormButton">
								{isLoading ? (
									<div className="dotContainer">
										<span className="dot"></span>
										<span className="dot"></span>
										<span className="dot"></span>
									</div>
								) : (
									"Register"
								)}
							</button>
						</>
					)}
				</form>
				<p className="popupToggleText">
					{isLogin ? "Don't have an account?" : "Already have an account?"}{" "}
					<span
						onClick={toggleCard}
						className="popupToggleLink"
					>
						{isLogin ? "Register" : "Login"}
					</span>
				</p>
			</div>
		</div>
	);
};

export default User;
